import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ClaimsService } from '../services/claims.service';
import { ClaimsBalanceSearchHandler } from './claims-balance-search.handler';

@Component({
  selector: 'sym-search-claims-balance',
  templateUrl: './claims-balance-search.component.html',
  styleUrls: ['./claims-balance-search.component.scss'],
})
export class ClaimsBalanceSearchComponent extends ClaimsBalanceSearchHandler implements OnInit {
  constructor(
    public service: ClaimsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
